import type { Engine } from '../../engine';
import { AbstractPlugin } from '../plugin';

export class ParticleLoader extends AbstractPlugin {
  engine: Engine;
}
